import { render } from "./CustomAvatarCropper.vue?vue&type=template&id=03d1ba02"
import script from "./CustomAvatarCropper.vue?vue&type=script&lang=js"
export * from "./CustomAvatarCropper.vue?vue&type=script&lang=js"

import "./CustomAvatarCropper.vue?vue&type=style&index=0&id=03d1ba02&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__